import { createActions, handleActions } from 'redux-actions';

import { TEXT, AUDIO, IMAGE } from '@coconut/constants/mimeTypes';
import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  SEND_TEXT_MESSAGE: 'SEND_TEXT_MESSAGE',
  SEND_AUDIO_MESSAGE: 'SEND_AUDIO_MESSAGE',
  SEND_IMAGE_MESSAGE: 'SEND_IMAGE_MESSAGE',

  SEND_MESSAGE_FAILED: 'SEND_MESSAGE_FAILED',
  SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',

  DELETE_MESSAGE: 'DELETE_MESSAGE',
  DELETE_MESSAGE_SUCCESS: 'DELETE_MESSAGE_SUCCESS',
  DELETE_MESSAGE_FAILED: 'DELETE_MESSAGE_FAILED',

  RESEND_MESSAGE: 'RESEND_MESSAGE',
  RESEND_MESSAGE_SUCCESS: 'RESEND_MESSAGE_SUCCESS',
  RESEND_MESSAGE_FAILED: 'RESEND_MESSAGE_FAILED',

  RESET_LOADING_STATUS: 'RESET_LOADING_STATUS',
};

export const {
  sendTextMessage,
  sendAudioMessage,
  sendImageMessage,
  sendMessageSuccess,
  sendMessageFailed,
  resetLoadingStatus,
  resendMessage,
  resendMessageSuccess,
  resendMessageFailed,
  deleteMessage,
  deleteMessageSuccess,
  deleteMessageFailed,
} = createActions(
  {
    [types.SEND_TEXT_MESSAGE]: (
      QID,
      userID,
      { description, lang, mtype = TEXT }
    ) => ({
      description,
      lang,
      mtype,
      QID,
      userID,
    }),
    [types.SEND_AUDIO_MESSAGE]: ({
      audioRecord,
      QID,
      userID,
      lang,
      mtype = AUDIO,
    }) => ({
      audioRecord,
      QID,
      userID,
      lang,
      mtype,
    }),
    [types.SEND_IMAGE_MESSAGE]: ({
      image,
      QID,
      userID,
      lang,
      mtype = IMAGE,
    }) => ({
      image,
      QID,
      userID,
      lang,
      mtype,
    }),
    [types.SEND_MESSAGE_SUCCESS]: ({ message }) => ({
      message,
    }),
    [types.SEND_MESSAGE_FAILED]: (errorMessage) => ({
      errorMessage,
    }),
    [types.RESEND_MESSAGE]: ({ id, QID }) => ({
      id,
      QID,
    }),
    [types.RESEND_MESSAGE_SUCCESS]: (message) => ({
      message,
    }),
    [types.RESEND_MESSAGE_FAILED]: (errorMessage) => ({
      errorMessage,
    }),
    [types.DELETE_MESSAGE]: (id) => ({
      id,
    }),
    [types.DELETE_MESSAGE_FAILED]: (errorMessage) => ({
      errorMessage,
    }),
  },
  types.RESET_LOADING_STATUS,
  types.DELETE_MESSAGE_SUCCESS
);

const INIT_STATE = {
  sentMessages: [], // store sent messages.
  loading: loadingState.EMPTY,
  errorMessage: '',
};

const reducer = handleActions(
  {
    [types.SEND_TEXT_MESSAGE]: (state) => ({
      ...state,
      loading: loadingState.LOADING,
    }),
    [types.SEND_AUDIO_MESSAGE]: (state) => ({
      ...state,
      loading: loadingState.LOADING,
    }),
    [types.SEND_IMAGE_MESSAGE]: (state) => ({
      ...state,
      loading: loadingState.LOADING,
    }),
    [types.SEND_MESSAGE_SUCCESS]: (state, action) => ({
      ...state,
      loading: loadingState.READY,
      sentMessages: state.sentMessages.concat(action.payload.message),
    }),
    [types.RESEND_MESSAGE]: (state) => ({
      ...state,
      loading: loadingState.LOADING,
    }),
    [types.RESEND_MESSAGE_SUCCESS]: (state, action) => ({
      ...state,
      loading: loadingState.READY,
      sentMessages: state.sentMessages.concat(action.payload.message),
    }),
    [types.RESEND_MESSAGE_FAILED]: (state, action) => ({
      ...state,
      loading: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.DELETE_MESSAGE]: (state) => ({
      ...state,
      loading: loadingState.LOADING,
    }),
    [types.DELETE_MESSAGE_SUCCESS]: (state) => ({
      ...state,
      loading: loadingState.READY,
    }),
    [types.DELETE_MESSAGE_FAILED]: (state, action) => ({
      ...state,
      loading: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.SEND_MESSAGE_FAILED]: (state, action) => ({
      ...state,
      loading: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.RESET_LOADING_STATUS]: (state) => ({
      ...state,
      loading: loadingState.EMPTY,
    }),
    [types.SEND_TAGGING_MESAGE]: (state) => ({
      ...state,
      loading: loadingState.LOADING,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getLoadingStatus = (state) => state.chat.sendChat.loading;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/sendChat.js